// extracted by mini-css-extract-plugin
export var animationContainer = "_j0-0";
export var asteriskIcon = "_j0-8";
export var conversationLeftSection = "_j0-4";
export var conversationListItem = "_j0-3";
export var conversationMiddleSection = "_j0-5";
export var conversationRightSection = "_j0-6";
export var detailsContent = "_j0-1";
export var listContainer = "_j0-7";
export var modalContent = "_j0-2";